module.exports = function() {
  return new Worker(__webpack_public_path__ + "3d25a2bd9decb5da.worker.js");
};